var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading loading--countdown d-flex flex-column justify-content-center"},[_c('div',{staticClass:"loading__inner"},[_c('span',{staticClass:"loading__counter"},[_vm._v("\n            "+_vm._s(this.countDown)+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }